/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Exchange200ResponseData } from './Exchange200ResponseData'
import {
  Exchange200ResponseDataFromJSON,
  Exchange200ResponseDataFromJSONTyped,
  Exchange200ResponseDataToJSON,
} from './Exchange200ResponseData'

/**
 *
 * @export
 * @interface Exchange200Response
 */
export interface Exchange200Response {
  /**
   *
   * @type {boolean}
   * @memberof Exchange200Response
   */
  status: boolean
  /**
   *
   * @type {Exchange200ResponseData}
   * @memberof Exchange200Response
   */
  data: Exchange200ResponseData
}

/**
 * Check if a given object implements the Exchange200Response interface.
 */
export function instanceOfExchange200Response(
  value: object
): value is Exchange200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function Exchange200ResponseFromJSON(json: any): Exchange200Response {
  return Exchange200ResponseFromJSONTyped(json, false)
}

export function Exchange200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Exchange200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: Exchange200ResponseDataFromJSON(json['data']),
  }
}

export function Exchange200ResponseToJSON(
  value?: Exchange200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: Exchange200ResponseDataToJSON(value['data']),
  }
}
